import { useFormik } from "formik";

import { ICandidate } from "../../shared/model/candidate.model";
import { IDocument } from "../../shared/model/document.model";
import { phoneType } from "../../shared/model/enumerations/phone-type.model";
import { IStepper } from "../../shared/model/IStepper";
import { getSchemaValidationFirstStep } from "./form/firstStep/validationSchema";
import { getSchemaValidationSecondStep } from "./form/secondStep/validationSchema";
import { getSchemaValidationThirdStep } from "./form/thirdStep/validationSchema";

interface IFormikPostulate {
  initialValues: ICandidate;
  stepper: IStepper;
  saveEntityConfirm: (data: ICandidate) => void;
  setErrorIncompleteFields: (data: boolean) => void;
}

export const useFormikPostulate = (props: IFormikPostulate) => {
  const { initialValues, stepper, saveEntityConfirm } = props;
  const getValidationSchema = (currentStep: number) => {
    switch (currentStep) {
      case 1:
        return getSchemaValidationFirstStep();
      case 2:
        return getSchemaValidationSecondStep();
      case 3:
        return getSchemaValidationThirdStep();
      default:
        return getSchemaValidationThirdStep();
    }
  };
  const formik = useFormik<ICandidate>({
    initialValues,
    enableReinitialize: true,
    validationSchema: getValidationSchema(stepper.current),
    onSubmit(values) {
      if (formik.isValid) {
        const newDocuments = values.documents?.filter(
          (doc: IDocument) => doc.file,
        );
        values.documents = newDocuments;
        values?.contactInformation?.partMobileNumber
          ? (values.contactInformation.mobileNumber = `${values.contactInformation.countryCode}9(${values.contactInformation.areaCode})${values.contactInformation.partMobileNumber}`)
          : null;
        values?.contactInformation?.partAlternativePhoneNumber
          ? (values.contactInformation.alternativePhoneNumber = `${values.contactInformation.alternativeCountryCode}${values.contactInformation.phoneType === phoneType.Movil ? "9" : ""}(${values.contactInformation.alternativeAreaCode})${values.contactInformation.partAlternativePhoneNumber}`)
          : null;
        saveEntityConfirm(values);
      } else {
        props.setErrorIncompleteFields(true);
      }
    },
  });
  return { formik };
};
